import { GridCol, GridContainer, GridRow, Icon, ICONS } from '@bob/library'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapFooter } from '@websrc/DataMappers/mapFooter'
import React, { useState } from 'react'

import * as SC from './FooterColor.style'

export type FooterColorProps = {
  color: ReturnType<typeof mapFooter>['color'] | null
}

export const FooterColor = ({ color }: FooterColorProps) => {
  const [mobileShow, setMobileShow] = useState(false)

  if (!color || color.disable) return null

  return (
    <SC.Wrapper>
      <GridContainer>
        <GridRow desktopAlignItems={'center'}>
          <GridCol desktop={3}>
            <SC.Title>{color.more_questions_title}</SC.Title>
            <SC.StyledButton onClick={() => setMobileShow((s) => !s)}>
              <span>{color.more_questions_title}</span>
              <Icon icon={mobileShow ? ICONS.ARROW_UP : ICONS.ARROW_DOWN} size={24} />
            </SC.StyledButton>
          </GridCol>
          <SC.ButtonWrapper desktop={9} mobileShow={mobileShow}>
            {color.buttons &&
              color.buttons.map((button, key) => (
                <SC.Link
                  href={button.button_link?.href !== undefined ? button.button_link.href : ''}
                  key={`${button?.button_link?.title}+${key}`}
                  onClick={() =>
                    matomo.trackEvent(
                      'engagement',
                      'all',
                      [color.more_questions_title],
                      [button.button_link?.title !== undefined ? button.button_link.title : ''],
                      'icon'
                    )
                  }
                >
                  {button.button_icon && <Icon icon={ICONS[button.button_icon]} size={40} />}
                  {button.button_link?.title && <span>{button.button_link.title}</span>}
                </SC.Link>
              ))}
          </SC.ButtonWrapper>
        </GridRow>
      </GridContainer>
    </SC.Wrapper>
  )
}
